import { createUseStyles } from 'react-jss';

var styles = {
  button: {
    width: '2.4rem',
    height: '2.4rem',
    backgroundColor: 'transparent',
    padding: 0,
    margin: {
      left: '0.4rem',
      right: '0.4rem'
    },
    border: 0,
    cursor: 'pointer'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map